export const SystemData = [
  {
    date: "New",
    list: [
      {
        unread: false,
        detail: "Your profile was viewed by 4 new coaches. Click to see.",
        time: "4 min ago",
        more: ["Mark as read", "Delete"]
      },
      {
        unread: true,
        detail: "Your profile was viewed by 4 new coaches. Click to see.",
        time: "36 min ago",
        more: ["Mark as read", "Delete"]
      },
      {
        unread: false,
        detail: "Your profile was viewed by 4 new coaches. Click to see.",
        time: "1 hr ago",
        more: ["Mark as read", "Delete"]
      },
      {
        unread: false,
        detail: "Your profile was viewed by 4 new coaches. Click to see.",
        time: "5 hr ago",
        more: ["Mark as read", "Delete"]
      }
    ]
  },
  {
    date: "Yesterday",
    list: [
      {
        unread: false,
        detail: "Your profile was viewed by 4 new coaches. Click to see.",
        time: "4 min ago",
        more: ["Mark as read", "Delete"]
      },
      {
        unread: false,
        detail: "Your profile was viewed by 4 new coaches. Click to see.",
        time: "4 min ago",
        more: ["Mark as read", "Delete"]
      },
      {
        unread: true,
        detail: "Your profile was viewed by 4 new coaches. Click to see.",
        time: "36 min ago",
        more: ["Mark as read", "Delete"]
      },
      {
        unread: true,
        detail: "Your profile was viewed by 4 new coaches. Click to see.",
        time: "1 hr ago",
        more: ["Mark as read", "Delete"]
      },
      {
        unread: false,
        detail: "Your profile was viewed by 4 new coaches. Click to see.",
        time: "5 hr ago",
        more: ["Mark as read", "Delete"]
      }
    ]
  },
  {
    date: "2nd October 2020",
    list: [
      {
        unread: false,
        detail: "Your profile was viewed by 4 new coaches. Click to see.",
        time: "4 min ago",
        more: ["Mark as read", "Delete"]
      },
      {
        unread: true,
        detail: "Your profile was viewed by 4 new coaches. Click to see.",
        time: "36 min ago",
        more: ["Mark as read", "Delete"]
      },
      {
        unread: false,
        detail: "Your profile was viewed by 4 new coaches. Click to see.",
        time: "1 hr ago",
        more: ["Mark as read", "Delete"]
      },
      {
        unread: false,
        detail: "Your profile was viewed by 4 new coaches. Click to see.",
        time: "5 hr ago",
        more: ["Mark as read", "Delete"]
      }
    ]
  }
];
